import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=ebe12922"
import script from "./BaseLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports